export default __webpack_public_path__ + "static/media/usa3.1dcde776.jpg";